export const elastic = (timeFraction: number, n = 2) => {
    return Math.pow(2, 10 * (timeFraction - 1)) * Math.cos(20 * Math.PI * n / 3 * timeFraction);
};
